import { Dependency } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';

export const VisualizationNoItemsMatchLayoutState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="flex items-center justify-center p-2 rounded-xl bg-bg-neutral">
        <Dependency className="h-8 w-8" />
      </div>

      <div className="text-xl font-bold">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.title)}
      </div>
      <div className="mb-2 text-text-neutral-secondary">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchLayoutOptions.description)}
      </div>
    </div>
  );
};
